export const TrainingRequestCatalog = {
    path: '/training_request_catalogs',
    name: 'training_request_catalogs',
    component: () => import('@/views/Training/Catalog/TrainingRequestCatalogPage.vue'),
    children: [
        {
            path: '/training_request_catalogs/add',
            name: 'training_request_catalogs.add',
            component: () => import('@/views/Training/Catalog/Form/CatalogForm.vue'),
            props: {addAction: true}
        },
        {
            path: '/training_request_catalogs/edit/:id',
            name: 'training_request_catalogs.edit',
            component: () => import('@/views/Training/Catalog/Form/CatalogForm.vue'),
            props: {updateAction: true}
        },
        {
            path: '/training_request_catalogs/delete/:id',
            name: 'training_request_catalogs.delete',
            component: () => import('@/views/Training/Catalog/Form/CatalogForm.vue'),
            props: {deleteAction: true}
        },
        {
            path: '/training_request_catalogs/view/:id',
            name: 'training_request_catalogs.view',
            component: () => import('@/views/Training/Catalog/Form/CatalogForm.vue'),
            props: {viewAction: true}
        },
        {
            path: '/training_request_catalogs/documents/:id',
            name: 'training_request_catalogs.documents',
            component: () => import('@/views/Edms/Document/ModuleDocumentPage.vue'),
            props: {module: "TRAINING_CATALOG"}
        },
    ],
}
